import UnauthenticatedPaths from '../../../routing/UnauthenticatedRoutes/UnauthenticatedRoutes.paths';
import { matchPath } from 'react-router-dom';
import { needsSignInConfirmed } from '../../state/Auth.selectors';

export const mapStateToProps = state => {
    return {
        needsSignInConfirmed:
            !matchPath(location.pathname, {
                path: `${UnauthenticatedPaths.SIGN_IN_CONFIRM}`,
            }) && needsSignInConfirmed(state),
    };
};
